import React from 'react';
import PropTypes from 'prop-types';

const PlusIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 10 10">
        <g transform="translate(-1145 -695)" fill={fill}>
            <rect width="2" height="10" rx="1" transform="translate(1149 695)" />
            <rect width="2" height="10" rx="1" transform="rotate(90 228 927)" />
        </g>
    </svg>
);

PlusIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

PlusIcon.defaultProps = {
    width: '10',
    height: '10',
    fill: '#707070'
};

export default PlusIcon;
